import React, { useState } from 'react';
import { Button, Tooltip } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Link } from 'react-router-dom';

interface ActionButtonCellProps {
  row: any;
  column: any;
  icon: IconProp;
  color?: string;
  disabled?: boolean;
  to?: any;
  onClick?(row: any, column: any): any;
  tooltip?: string;
  modal?: any;
}
/**
 * PageSizeDropwdown
 *
 */
export const ActionButtonCell = ({ row, column, tooltip, icon, to, color = "primary", disabled = false, onClick, modal = undefined}: Readonly<ActionButtonCellProps>): JSX.Element => {
  const [ toggleTooltip, setToggleTooltip ] = useState(false);
  const [ open, setOpen] = useState(false);

  const compId = `r${row.index}-l${column.id}-toggle`;

  return (
    <React.Fragment>
      <Button 
        id={compId} 
        disabled={disabled}
        data-toggle="tooltip" 
        color={color} 
        tag={Link} 
        to={to ? to : undefined} 
        onClick={onClick ? () => onClick(row, column) : () => setOpen(true)}>
        <FontAwesomeIcon aria-hidden="true" icon={icon} />
        <span className="sr-only">{tooltip}</span>
      </Button>
      {tooltip &&
        <Tooltip target={compId} isOpen={toggleTooltip} toggle={() => setToggleTooltip(!toggleTooltip)}>
          {tooltip}
        </Tooltip>
      } 
      {modal &&
        modal(open, setOpen, row.original)}
      
    </React.Fragment>
  );
}

